import { useEffect, useRef } from "react";

// `pronto` existe para quem só monta o conteúdo depois de uma resposta da API:
// no primeiro render o ref ainda é nulo, o efeito desiste e — como as deps não
// mudavam — o observer nunca era criado, deixando a seção em opacity 0.
export function useScrollReveal(threshold = 0.15, pronto = true) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || !pronto) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      el.classList.add("revealed");
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("revealed");
          observer.unobserve(el);
        }
      },
      { threshold }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold, pronto]);
  return ref;
}
